export const formatCurrency = (value) =>
    new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value || 0);

export const formatK = (v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : `${v}`);

export const ROLE_LABELS = { commerciale: 'Commerciale', area_manager: 'Area Manager', admin: 'Admin' };
